import {GetArrayFromRecursive, GetFlatArrayFromRecursive, normalizeItems} from '../../helpers/Helpers';

const initialState = {
    flat: [],
    items: [],
    filtered: [],
    select: [],
    menu: [],
    single: {},
    parentWorkspaceId: null
};

export default (state = initialState, action) => {
    switch (action.type) {

        case "BLOCK_RESET":
            return initialState;

        case 'BLOCK_FILTER':
            return {
                ...state,
                filtered: action.payload.data
            };
        case 'GET_GLOBALS_FOR_WORKSPACE':
            return {
                ...state,
                items: action.payload.blocks,
                filtered: action.payload.blocks,
                menu: normalizeItems(action.payload.blocks),
                flat: GetFlatArrayFromRecursive(action.payload.blocks),
                select: GetArrayFromRecursive(action.payload.blocks),
                parentWorkspaceId: action.payload.parentWorkspaceId
            };
        case 'BLOCK_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
        case 'BLOCK_STRUCTURE_SUCCESS':
            if (action.payload.skipStore === false) {
                return {
                    ...state,
                    items: action.payload.data,
                    filtered: action.payload.data,
                    menu: normalizeItems(action.payload.data),
                    flat: GetFlatArrayFromRecursive(action.payload.data),
                    select: GetArrayFromRecursive(action.payload.data),
                    parentWorkspaceId: action.payload.parentWorkspaceId
                };
            } else {
                return {
                    ...state
                }
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/block.js